export default angular.module("MyReportsWidgetModule", ["MyReportsFactoriesModule", "TeamsApp"]);